export class ReferralMedical{
    idControlFormulario: string;
    
    // datos para la respuesta
    data: any;
}